import { createContext } from 'react';

import { SelectedGroupTerminalPermissionContextProps } from './SelectedGroupTerminalPermissionContext.types';

export const SelectedGroupTerminalPermissionContext = createContext<
  SelectedGroupTerminalPermissionContextProps | undefined
>(undefined);
